import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers';
import { format } from 'date-fns';
import { allOperators, standardOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { practiceLabel } from '../../../../utils/adviseRoles';

export const DefaultTeamGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    field: 'account_name',
    headerName: 'Account Name',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'practice',
    headerName: 'Advise Practice',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    valueFormatter: (value: string | null) => (value ? practiceLabel(value) : ''),
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: true,
    flex: 1,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'user_count',
    headerName: 'User Count',
    sortable: true,
    width: 65,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'team_managers_text',
    headerName: 'Team Managers',
    filterable: true,
    type: 'singleSelect',
    flex: 1,
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'created_at',
    headerName: 'Created At',
    sortable: true,
    valueFormatter: (value) => {
      return value ? format(value, 'PPpp') : '';
    },
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: allOperators(),
    description: 'Drag to move column'
  }
];
